<template>
  <DModal :show-close="false" :isBgOverlay="true" @close="$emit('close')" :appendToBody="true"
          style="z-index: 12312312312312" :placeInTop="true">
    <div class="d-modal" id="d-create-task-for-user" slot="insertComponent">
      <div class="d-modal__header">
        <h2>{{ editSupplement ? 'Rediger tillæg' : 'Opret tillæg' }}</h2>
        <div class="font-large icon__bg-circle d-modal__header__close" @click="$emit('close')">
          <span class="icon-cross2"></span>
        </div>
      </div>
      <div class="d-modal__content">
        <div class="do-form-row">
          <div class="d-input-group">
            <label class="d-label">Vælg ansat</label>
            <select v-model="userId" class="height-34 do-select width-100" @change="onUserChange($event.target.value)">
              <option disabled value="">Vælg ansat</option>
              <option v-for="user in usersSortedOnName"
                      :value="user.id">
                {{ user.name }}
              </option>
            </select>
          </div>
          <!--
                  <div class="d-input-group">
                    <label class="d-label">Ansættelses-ID</label>
                    <input type="number" class="d-input" v-model="employmentId">
                  </div>
          -->
          <div class="d-input-group">
            <label class="d-label">Brutto årsnorm</label>
            <input type="number" class="d-input" v-model="yearNormHours">
          </div>

          <div class="d-input-group">
            <label class="d-label">Tillægstype</label>
            <select v-model="code" class="height-34 do-select width-100">
              <option v-for="supplementType in supplementTypes" :value="supplementType.code">
                {{ supplementType.code }} - {{ supplementType.title }}
              </option>
            </select>
          </div>
          <div class="d-input-group">
            <label class="d-label">Konto</label>
            <input type="text" class="d-input" v-model="account">
          </div>
        </div>
        <div class="do-form-row">
          <div class="d-input-group">
            <label class="d-label">Startdato</label>
            <DateSelector class="width-100" :date="startDate" :width100="true" @input="val => startDate = val"/>
          </div>

          <div class="d-input-group">
            <label class="d-label">Slutdato</label>
            <DateSelector :date="endDate" :width100="true" @input="val => endDate = val"/>
          </div>

          <div class="d-input-group">
            <label class="d-label">Enheder i periode</label>
            <input type="number" class="d-input" v-model="units">
          </div>

          <div class="d-input-group">
            <label class="d-label">Antal udbetalinger</label>
            <input type="number" class="d-input" v-model="installments">
          </div>

          <div class="d-input-group">
            <label class="d-label">Enheder pr. måned</label>
            <input type="number" class="d-input" v-model="unitsPerInstallment">
          </div>
        </div>
      </div>
      <div class="d-modal__buttons">
        <div class="d-modal__buttons__left">
          <button class="do-bttn" v-if="editSupplement" @click="isConfirmDelete = true"><span class="icon-bin"></span></button>
        </div>
        <div class="d-modal__buttons__right">
          <button class="do-bttn" @click="$emit('close')">{{ $t('vue2.common.cancel') }}</button>
          <button class="do-bttn do-bttn--submit"
                  :class="{'do-bttn--submit--loading': isSubmitting}"
                  :disabled="!isValid"
                  @click="submit">
            {{ editSupplement ? 'Opdater' : 'Opret' }}
          </button>
        </div>
      </div>
      <ModalConfirmation
        v-if="isConfirmDelete"
        :showClose="false"
        @close="isConfirmDelete = false"
        @confirm="$emit('delete', editSupplement.id)"></ModalConfirmation>
    </div>
  </DModal>
</template>

<script>
import DModal from '../common/DModal.vue'
import DateSelector from '../datepicker/DateSelector.vue'
import moment from 'moment'
import docendo from '../../docendo'
import ModalConfirmation from '../Modals/ModalConfirmation.vue'

export default {
  components: {ModalConfirmation, DModal, DateSelector},
  props: {
    isSubmitting: {
      type: Boolean,
      default: false
    },
    supplementTypes: {
      type: Array,
      default: () => []
    },
    schoolId: {},
    schoolYearId: {},
    schoolYear: {},
    editSupplement: {
      default: () => null
    }
  },
  data () {
    return {
      userId: '',
      employmentId: null,
      yearNormHours: null,
      startDate: moment(),
      endDate: moment(),
      code: '',
      account: '',
      units: null,
      installments: null,
      unitsPerInstallment: null,
      isConfirmDelete: false
    }
  },
  computed: {
    isValid () {
      return this.userId && this.yearNormHours && this.code
    },
    usersSortedOnName () {
      return this.$store.getters.usersSortedOnName
    }
  },
  methods: {
    onUserChange (userId) {
      this.readUser()
    },
    readUser () {
      docendo.schoolUserYearsList(this.schoolId, this.schoolYearId, this.userId, success => {
        const userNorms = success && success[0] && success[0].norm ? success[0].norm : []
        if (userNorms.length) {
          const bruttoTime = userNorms.find(userNorm => userNorm.title === 'Bruttotid')
          if (bruttoTime && bruttoTime.value) {
            this.yearNormHours = parseFloat(bruttoTime.value)
          }
        } else {
          this.yearNormHours = null
        }
      }, failure => {
        console.log({failure})
      })
    },
    submit () {
      let supplement = {
        userId: this.userId,
        employmentId: this.employmentId,
        yearNormHours: this.yearNormHours,
        startDate: this.startDate,
        endDate: this.endDate,
        code: this.code,
        account: this.account,
        units: this.units,
        installments: this.installments,
        unitsPerInstallment: this.unitsPerInstallment
      }
      if (this.editSupplement) {
        supplement['id'] = this.editSupplement.id
        this.$emit('update', supplement)
        return
      }
      this.$emit('save', supplement)
    }
  },
  mounted () {
    if (this.schoolYear) {
      const start = this.schoolYear.employee_time_start
      const end = this.schoolYear.employee_time_end
      this.startDate = moment(start).format('YYYY-MM-DD')
      this.endDate = moment(end).format('YYYY-MM-DD')
    }

    if (this.editSupplement) {
      this.userId = this.editSupplement.user_id || ''
      this.employmentId = this.editSupplement.employment_id || null
      this.yearNormHours = this.editSupplement.year_norm_hours ? parseFloat(this.editSupplement.year_norm_hours) : null

      if (this.editSupplement.valid_period && this.editSupplement.valid_period.includes('...')) {
        const dates = this.editSupplement.valid_period.split('...')
        this.startDate = moment(dates[0]).format('YYYY-MM-DD')
        this.endDate = moment(dates[1]).format('YYYY-MM-DD')
      }

      this.code = this.editSupplement.code || ''
      this.account = this.editSupplement.account || ''
      this.units = this.editSupplement.units ? parseFloat(this.editSupplement.units) : null
      this.installments = this.editSupplement.installments || null
      this.unitsPerInstallment = this.editSupplement.units_per_installment ? parseFloat(this.editSupplement.units_per_installment) : null
    }
  }
}
</script>

<style scoped>
@import "../../assets/css/variables.css";

.d-modal {
  width: 1000px;
  border-radius: 16px;
  position: relative;
}

.d-modal__header {
  margin-bottom: 0;
  text-align: left;
}

.d-modal__buttons {
  display: flex;
  justify-content: space-between;
  gap: 1rem;
  padding: 1rem 2rem;
  border-top: 1px solid #eee;
  margin: 0;
}

.d-modal__buttons > div {
  display: flex;
  align-items: center;
  gap: 1rem;
}

.d-modal__content {
  padding: 1rem;
  overscroll-behavior: contain;
}

.d-input-group--toggler {
  display: flex;
  align-items: center;
  justify-content: space-between;
  background: #fff;
  padding: 1rem;
  border-radius: 4px;
  cursor: pointer;
  box-shadow: 0 1px 3px 0 rgba(0, 0, 0, .1), 0 1px 2px -1px rgba(0, 0, 0, .1);
}

.d-input-group--toggler.d-input-group--toggler--active > .d-label {
  color: var(--dark-blue);
}

.d-input-group--toggler > .d-label {
  margin-bottom: 0;
  cursor: pointer;
}

.d-input-group--toggler:hover {
  background: #f0f8ff;
}

.d-input-group .d-input {
  height: 34px;
}

.d-input-group {
  margin-bottom: 2rem;
}

.d-modal__content {
  max-height: calc(100vh - 52px - 50px);
  overflow-y: auto;
}

.do-form-row {
  display: flex;
  gap: 1rem;
}

.do-form-row > div {
  flex: 1;
}

.height-34 {
  height: 34px;
  margin-top: 0.25rem;
}

</style>



// WEBPACK FOOTER //
// CreateSupplement.vue?41d5027e